export class MailFoldersDb {
  public static list = [
    {
      'id': 1,
      'handle': 'inbox',
      'title': 'Inbox',
      'icon': 'inbox'
    },
    {
      'id': 2,
      'handle': 'sent',
      'title': 'Sent',
      'icon': 'send'
    },
    {
      'id': 3,
      'handle': 'drafts',
      'title': 'Drafts',
      'icon': 'open-mail'
    },
    {
      'id': 4,
      'handle': 'spam',
      'title': 'Spam',
      'icon': 'spam'
    },
    {
      'id': 5,
      'handle': 'trash',
      'title': 'Trash',
      'icon': 'trash'
    },
    {
      'id': 6,
      'handle': 'archive',
      'title': 'Archive',
      'icon': 'archive'
    }
  ];
}
